<template>
    <div>
        <label class="col-sm-4 lh40 text-lr"><i
                v-if=" Data.data.c_priority==='S'"
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 " v-for="(item,index) in temp_list" :key="index">
        <el-input v-model="item.name" placeholder="请输入内容"></el-input>
        <el-time-picker
                is-range
                @change="dealData(index)"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                v-model="item.value"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围">
        </el-time-picker>
        <span style="margin-left: 5px">  <el-button type="text" @click="add_temp()">+</el-button>
         <el-button type="text" @click="min_temp(index)" v-if="temp_list.length>1">-</el-button></span>
      </div>
    </div>
</template>

<script>
export default {
    name: "time_range",
    props: [
        'Data',
    ],
    data() {
        return {
            // value: this.Data.data.c_value === null ? ['08:00','18:00'] : this.Data.data.c_value.split(','),
          temp_list:[{'name':'',value:['08:00','18:00']}]
         };
    },
    mounted() {
        this.$get_function(this.Data,this.value)//默认值
        },
    methods: {
      dealData(index){
        var list={}
        list[this.templist[index].name]={'start':this.value[0],'end':this.value[1]}
          this.$get_function(this.Data,list)
        },
      min_temp(index){
        this.temp_list.splice(index,1)
      },
      add_temp(){
        this.temp_list.push({'name':'',value:['08:00','18:00']})
      },
    }
}
</script>

<style scoped>

</style>